export default function mountVueToBody(instance: Vue) {
  const div = document.createElement('div')
  document.body.appendChild(div)
  instance.$mount(div)
  const destroyer = () => {
    if (instance === null) {
      return
    }
    instance.$destroy()
    instance.$el.remove()
  }
  return destroyer
}
